module.exports = __webpack_public_path__ + "static/media/konnexions_logo.23c6c89e.png";